import React from "react";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import withLocationSearchFilter from '../../../../hocs/with_location_search_filter.js';
import withCurrentUser from '../../../../hocs/with_current_user.js.jsx';
import withShowToast from '../../../../hocs/with_show_toast.js.jsx';
import withShowModal from '../../../../hocs/with_show_modal.js.jsx';
import withScrollHandler from "../../../../hocs/with_scroll_handler.js";

import pageStyles from "../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../base_info_page.js.jsx";

import BaseInfoPage from "../../base_info_page.js.jsx";
import { ButtonVariantOutlined } from "../../../../base/buttons/constants.js.jsx";
import Button from "../../../../base/buttons/button.js.jsx";
import ButtonLink from "../../../../base/links/button_link.js.jsx";

import I18n from "../../../../base/i18n.js.jsx";

import { DownloadableModel } from "../../../../models/downloadables/downloadable_model.js.jsx";

import ShowDownloadableUseCase from "../../../../use_cases/admin/downloadables/show_downloadable_use_case.js.jsx";
import SaveDownloadableUseCase from "../../../../use_cases/admin/downloadables/save_downloadable_use_case.js.jsx";
import DeleteDownloadableUseCase from "../../../../use_cases/admin/downloadables/delete_downloadable_use_case.js.jsx";

import InfoPageHeader from "../../components/info_page_header.js";
import NavigationTabs from "../../components/navigation_tabs.js";

import DownloadableInfoTab from "./components/downloadable_info_tab.js.jsx"
import DownloadableSubscribersTab from "./components/downloadable_subscribers_tab.js.jsx"

import AdminRoutes from "../../../routes.js.jsx";
import WebRoutes from "../../../../web/routes.js.jsx";

const styles = theme => ({
  preview: {
    marginLeft: "20px",
    padding: "4px 15px"
  },
});

const InfoTab        = "info";
const SubscribersTab = "subscribers";

class DownloadableInfoPage extends BaseInfoPage {

  constructor(props) {
    super(props);

    this.tabs = [
      {
        identifier: InfoTab,
        label: I18n.t("admin.downloadables.downloadable.tabs.info")
      },
      {
        identifier: SubscribersTab,
        label: I18n.t("admin.downloadables.downloadable.tabs.subscribers"),
      }
    ]

    if(!this.state.currentTab) {
      this.state.currentTab = this.tabs[0].identifier;
    }
    this.state.filesIsLoaded = true;
  }

  defaultItem() {
    return {
      slug: this.identifier,
      key: "notLoadedItem"
    }
  }

  onItemChange(changedItem) {
    this.item = {
      ...this.item,
      ...changedItem
    };
    this.updateIsLoadingFiles();
  }

  updateIsLoadingFiles = () => {
    var filesIsLoaded = true;

    this.item.documents.forEach(file => filesIsLoaded = filesIsLoaded && !file.loading);

    this.setState({
      filesIsLoaded: filesIsLoaded
    })

  }

  beforeSaveProcessing() {
    this.item.documents = (this.item.documents || []).filter((document) => {
      const { pdfId, pdf } = document;
      return pdfId || pdf;
    })
  }

  loadItem() {
    if(this.identifier) {
      this.processDataLoader(this.showUseCase.execute(this.identifier));
    }
    else {
      this.item.key = "newItem";
      this.setState({
        loading: false
      });
    }
  }

  deleteConfirmMessage() {
    return I18n.t("admin.downloadable.delete.confirm_message", {
      name: this.dataModel.displayValue(this.item)
    });
  }

  header() {
    const { currentTab } = this.state;
    return <React.Fragment>
      <InfoPageHeader title = { this.pageTitle() }
                      subtitle = { this.pageSubtitle() } >
       </InfoPageHeader>
      {
        this.identifier &&
        <NavigationTabs tabs = { this.tabs }
                        currentTab = { currentTab }
                        onChangeTab = { this.onChangeTab } />
      }
    </React.Fragment>
  }

  processLoadedItem(result) {
    const { data: { downloadable } } = result;
    this.item = downloadable;
  }

  buttonsIsVisible() {
    const { currentTab } = this.state;
    return currentTab === InfoTab;
  }

  processLoadedItem(result) {
    const { data: { downloadable } } = result;
    this.item = downloadable;
  }

  leftButtons() {
    const { classes } = this.props;
    const { submit, loading } = this.state;

    return <React.Fragment>
      <Button className = { classes.button }
              type = { "submit" }
              disabled = { submit || loading } >
        { I18n.t("action.save") }
      </Button>
      {
        this.item && this.item.slug &&
        <ButtonLink className = { clsx(classes.button, classes.preview) }
                    variant = { ButtonVariantOutlined }
                    to = { WebRoutes.downloadable(this.item) }
                    target = { "_blank" }>
          { I18n.t("shared.preview") }
        </ButtonLink>
      }
    </React.Fragment>
  }

  rightButtons() {
    const { classes } = this.props;
    const { submit, loading } = this.state;

    return <React.Fragment>
      {
        this.identifier &&
          <Button className = { clsx(classes.formButton, classes.delete) }
                disabled = { submit || loading }
                onClick = { this.onDelete } >
          { I18n.t("action.delete") }
        </Button>
      }
    </React.Fragment>
  }

  subscribersTab = () => {
    return this.tabs.filter(tab => tab.identifier === SubscribersTab)[0];
  }

  content() {
    const { errorData, currentTab, loading } = this.state;

    if(loading) return <React.Fragment key = { this.item.key } />

    return <React.Fragment key = { this.item.key } >
      <DownloadableInfoTab downloadable = { this.item }
                                  validations = { this.validations }
                                  errorData = { errorData }
                                  onItemChanged = { this.onItemChange }
                                  visible = { currentTab === InfoTab } />
      {
        this.identifier && <DownloadableSubscribersTab downloadable = { this.item }
                                                      visible = { currentTab === SubscribersTab }
                                                      filterData = { {...this.subscribersTab().queryParams} }
                                                      onChangeFilter = { this.onChangeFilter } />
      }


    </React.Fragment>
  }
}

DownloadableInfoPage.defaultProps = {
  dataModel: DownloadableModel,
  showUseCase: ShowDownloadableUseCase,
  saveUseCase: SaveDownloadableUseCase,
  deleteUseCase: DeleteDownloadableUseCase,
  routeFunc: AdminRoutes.downloadable
}

export default compose(
  withLocationSearchFilter,
  withRouter,
  withShowToast,
  withCurrentUser,
  withShowModal,
  withScrollHandler,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(DownloadableInfoPage);
